var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column wrapper"},[_c('div',{staticClass:"d-flex px-4"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('v-btn',{attrs:{"text":"","color":"#0fff95"},on:{"click":_vm.ButtonClickFunction}},[_vm._v(" ATUALIZAR ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }